import axios from 'axios'
import { API_ROOT, API_TIMEOUT } from '../../config/config'
import { doGet } from './utils'

// const API_ROOT = 'http://localhost:9001/api'
export const getProvince = () => {
  const url = `${API_ROOT}/portal/location/dropdown/get`
  return axios
    .post(url, {}, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const getDistrict = (provinceId) => {
  const url = `${API_ROOT}/portal/location/dropdown/get`
  return axios
    .post(
      url,
      {
        provinceId,
      },
      API_TIMEOUT
    )
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const getSubDistrict = (provinceId, districtId, isHaveZipCode) => {
  const url = `${API_ROOT}/portal/location/dropdown/get`
  return axios
    .post(
      url,
      {
        provinceId,
        districtId,
        isHaveZipCode,
      },
      API_TIMEOUT
    )
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const searchLocation = (locationName, isHaveZipCode) => {
  const url = `${API_ROOT}/portal/location/dropdown/search`
  return axios
    .post(
      url,
      {
        locationName,
        isHaveZipCode,
      },
      API_TIMEOUT
    )
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const getLocation = () => {
  const url = `${API_ROOT}/portal/location/dropdown/json`
  return doGet(url)
}

export const getLocationZipcode = () => {
  const url = `${API_ROOT}/portal/location/dropdown/json/zipcode`
  return doGet(url)
}

export const getLocationHaveAll = () => {
  const url = `${API_ROOT}/portal/location/dropdown/json/haveall`
  return doGet(url)
}

// export const saveProjectType = (id, schema) => {
//   const url = `${API_ROOT}/proposal/${id}/project-type-info`
//   return axios
//     .post(url, schema)
//     .then((response) => {
//       console.log('response', response)
//       return response.data
//     })
//     .catch((error) => {
//       throw error
//     })
// }

// export const updateProjectType = (id, schema, typeId) => {
//   const url = `${API_ROOT}/proposal/${id}/project-type-info${typeId}`
//   return axios
//     .put(url, schema)
//     .then((response) => {
//       console.log('response', response)
//       return response.data
//     })
//     .catch((error) => {
//       throw error
//     })
// }
